import { render, staticRenderFns } from "./ExportClients.vue?vue&type=template&id=8db081fc"
import script from "./ExportClients.vue?vue&type=script&lang=js"
export * from "./ExportClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports